const currentProductPageScript = document.querySelector('[data-registrationNumber]')
const registrationNumberProductPage = currentProductPageScript.getAttribute('data-registrationNumber');

class ProductPageEnergyLabel extends HTMLElement {
  constructor() {
    super();
   this.init();
  }

  async init() {
    let badges;
    if(document.querySelector(".energy-badge__button")){
      return ;
    }
    if(registrationNumberProductPage){
      badges = await this.getBadgeByRegistrationNumber()
    }else if(Shopify.designMode){
      badges = [{'eprel_number': '', title: '', badge:{badge:''} }];
    }else{
      return ;
    }

    const energyBadgeContainer = document.querySelector('.energy-badge__container.single-product')
    if(energyBadgeContainer.children.length > 0){
      return;
    }

    this.appendEnergyBadge(badges)
    if (badges.error) return console.warn(badges.error)
  }

  async getBadgeByRegistrationNumber() {
    const response = await fetch(`/apps/energy-label/api/products/badges`,{
      method: "POST",
      body: JSON.stringify({ 'typeData' : 'productComplexEprel', 'data' : registrationNumberProductPage})
    })
    const badges = await response.json()
    return badges
  }

  appendEnergyBadge(badges) {
    badges.forEach((value, index) => {
      let energyBadge = document.querySelector('.energy-badge__template').content.cloneNode(true);
      energyBadge.firstElementChild.setAttribute('data-index', index);
      energyBadge.firstElementChild.setAttribute('data-eprel', value.eprel_number);
      if(value.title){
        energyBadge.querySelector('.energy-badge__link-title').innerText = value.title.trim();
      }
      energyBadge.querySelector('.energy-badge__image').src = value.badge.base64 || 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCA0MCAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMCAwTDAgMTFMMTAgMjJINDBWMEgxMFpNMzEuNSAyMVYxSDM5VjIxSDMxLjVaTTI1LjM1MzUgNi4zNTM1M0wyMC43MDcxIDExTDI1LjM1MzUgMTUuNjQ2NEwyNC42NDY0IDE2LjM1MzVMMjAgMTEuNzA3MUwxNS4zNTM1IDE2LjM1MzVMMTQuNjQ2NCAxNS42NDY0TDE5LjI5MjkgMTFMMTQuNjQ2NCA2LjM1MzUzTDE1LjM1MzUgNS42NDY0MkwyMCAxMC4yOTI5TDI0LjY0NjQgNS42NDY0MkwyNS4zNTM1IDYuMzUzNTNaIiBmaWxsPSIjNzY3Njc2Ii8+Cjwvc3ZnPg=='
      if (!value.badge.error && value.eprel_number) energyBadge.querySelector('.energy-badge__link').href = `/apps/energy-label/api/products/${value.eprel_number}/sheets`
      if (value.badge.error) this.disableEnergyBadge()
      const energyBadgeContainer = document.querySelector('.energy-badge__container.single-product');
      energyBadgeContainer.appendChild(energyBadge)
    });

  }

  disableEnergyBadge() {
    document.querySelector('.energy-badge__container.single-product').classList.add('energy-badge__container--disabled')
  }
}
customElements.define('product-page-energy-label', ProductPageEnergyLabel)
